export function getFileNameFromS3Key(s3Key: string) {
    // Split the S3 key by '/' and return the last element
    if (s3Key) {
      return s3Key.split('/').pop();
    }
  }